/*
 * MDB shim for Spinner
 * Files currently importing this symbol from "mdbreact":
 * - src/Seating/Accounts/accountDetail.jsx
 * - src/Seating/Accounts/accountList.jsx
 * - src/Seating/Activities/activities-edit.jsx
 * - src/Seating/Activities/activities-list.jsx
 * - src/Seating/Deliveries/deliveryList.jsx
 * - src/Seating/Deliveries/inventoryTracking.jsx
 * - src/Seating/Deliveries/readyToScheduleGrid.jsx
 * - src/Seating/Faxes/faxes.jsx
 * - src/Seating/InventoryProduct/inventoryProductTable.jsx
 * - src/Seating/Orders/ATPView.jsx
 * - src/Seating/Orders/RecurringOrders.jsx
 * - src/Seating/Orders/collectionsView.jsx
 * - src/Seating/Orders/orderList.jsx
 * - src/Seating/Orders/salesPipelineView.jsx
 * - src/Seating/Patient/PatientViewComponents/attachmentsTab.jsx
 * - src/Seating/Patient/deliveryManifest.jsx
 * - src/Seating/Patient/patientInformationView.jsx
 * - src/Seating/Patient/patientOrderView.jsx
 * - src/Seating/PresidentsClub/presidentsClubView.jsx
 * - src/Seating/PurchaseQueue/ShippingDetailsReport.jsx
 * - src/Seating/PurchaseQueue/inventoryRequestTable.jsx
 * - src/Seating/Reports/accountReport.jsx
 * - src/Seating/Reports/activityReport.jsx
 * - src/Seating/Reports/approvalReport.jsx
 * - src/Seating/Reports/complaintReport.jsx
 * - src/Seating/Reports/deliveryReport.jsx
 * - src/Seating/Reports/expensesReport.jsx
 * - src/Seating/Reports/reports.jsx
 * - src/Seating/Reports/salesReport.jsx
 * - src/Seating/Reports/serviceOrderReasonReport.jsx
 * - src/Seating/Reports/servicesReport.jsx
 * - src/Seating/Settings/creditCardTypes.jsx
 * - src/Seating/Settings/deliveryAcknowledgements.jsx
 * - src/Seating/Settings/editProductSubTypes.jsx
 * - src/Seating/Settings/expenseTypes.jsx
 * - src/Seating/Settings/productMatrixEntry.jsx
 * - src/Seating/Settings/productTypes.jsx
 * - src/Seating/Settings/reasons.jsx
 * - src/Seating/Settings/stateSalesTax.jsx
 * - src/Seating/Settings/trainingLink.jsx
 * - src/Seating/Settings/vendor.jsx
 * - src/Seating/Tasks/taskTable.jsx
 * - src/Seating/Users/thirdPartyUserList.jsx
 * - src/Seating/Users/userEdit.jsx
 */

import MUICircularProgress from "@mui/material/CircularProgress";

export default function Spinner(props) {
  return <MUICircularProgress {...props} />;
}
